import { forwardRef, type Ref, type SVGProps } from "react";
const IconTargetFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.332 18.864c.517-2.501.348-5.08-.466-7.466l-4.981-.007a9.63 9.63 0 0 1 .98 6.521 9.4 9.4 0 0 1-3.509 5.585 9.15 9.15 0 0 1-6.27 1.843 9.2 9.2 0 0 1-5.907-2.817 9.45 9.45 0 0 1-2.604-6.073 9.48 9.48 0 0 1 1.998-6.305 9.23 9.23 0 0 1 5.603-3.397c2.187-.4 4.617.01 6.527 1.158.027-2.74.005-5.006.005-5.006s-3.733-1.397-7.34-.71A13.78 13.78 0 0 0 5 7.263a14.15 14.15 0 0 0-2.983 9.417 14.12 14.12 0 0 0 3.888 9.07 13.73 13.73 0 0 0 8.823 4.207 13.67 13.67 0 0 0 9.364-2.753 14.04 14.04 0 0 0 5.24-8.34" />
    <path
      fillRule="evenodd"
      d="m26.724 3.078.193 1.52 1.12-1.048a.484.484 0 0 1 .691.028.5.5 0 0 1-.028.701l-.956.895 1.283.227c.995.176 1.32 1.46.534 2.101l-2.962 2.415a2.7 2.7 0 0 1-1.866.608l-2.556-.143L16.17 16a.484.484 0 0 1-.691-.028.5.5 0 0 1 .028-.701l6.004-5.617-.025-2.452a2.8 2.8 0 0 1 .682-1.864l2.51-2.894c.666-.77 1.915-.382 2.045.634m-3.745 6.554 1.797.1c.482.027.957-.127 1.333-.434l2.961-2.415a.399.399 0 0 0-.177-.7L27.02 5.85zm2.11-3.324-2.802 2.621-.018-1.735c-.005-.49.169-.964.488-1.331l2.509-2.895a.39.39 0 0 1 .682.211l.256 2.014z"
      clipRule="evenodd"
    />
    <path d="M21.626 12.236s.154.261.224.395a7.1 7.1 0 0 1 .79 3.797 7.05 7.05 0 0 1-2.282 4.716 6.85 6.85 0 0 1-4.872 1.78 6.86 6.86 0 0 1-4.722-2.155 7.06 7.06 0 0 1-1.918-4.88 7.06 7.06 0 0 1 1.963-4.862 6.86 6.86 0 0 1 4.743-2.11c1.453-.043 4.065 1.197 4.065 1.197-.71.66-2.82 2.672-2.82 2.672s-.749-.184-1.14-.173a3.24 3.24 0 0 0-2.24.997 3.34 3.34 0 0 0-.927 2.297c-.004.858.32 1.685.906 2.305a3.24 3.24 0 0 0 2.23 1.018 3.24 3.24 0 0 0 2.302-.841 3.33 3.33 0 0 0 1.078-2.228c.031-.437-.156-1.279-.156-1.279z" />
  </svg>
);
const ForwardRef = forwardRef(IconTargetFilledSVG);
ForwardRef.displayName = "IconTargetFilled";
export { ForwardRef as IconTargetFilled };
